export enum RadioInputOrientationTypeEnum {
  Vertical,
  Horizontal,
}
